import {
    TYPE_PROJECTS_RESIDENTIAL,
  } from "@/constants/presale";

export const getTypeProjectPresaleFromCode = (code) => {
    let typeProject
    switch (true) {
        case code.includes('PVRC'):
            typeProject = 'B2C'
            break
        case code.includes('PVRB'):
            typeProject = 'B2B'
            break
        case code.includes('PVCO'):
            typeProject = 'Venta Organica'
            break
        case code.includes('PVCG'):
            typeProject = 'Grandes Clientes'
            break
        default:
            return null
    }
    return typeProject
}

export const getQueryParamsFromPresale = (presale) => {
    let have_project = presale.project !== null ? "true" : "false";
    let type_sale = presale.code.includes("PVRC")
      ? TYPE_PROJECTS_RESIDENTIAL[0].id
      : TYPE_PROJECTS_RESIDENTIAL[1].id;

    return {
        'presale_code': presale.id,
        'presale_name': presale.name,
        'presale_type': type_sale,
        'have_project': have_project,
        'approved_status': presale.approved_status
    }
}